import React from 'react';
import css from './index.module.scss';
import ServiceFooter from './ServiceFooter';
import SiteFooter from './SiteFooter';

const GlobalFooter: React.FC<React.HTMLProps<{}>> = () => {
  return (
    <footer className={css.GlobalFooter}>
      <ServiceFooter />
      <SiteFooter />
    </footer>
  );
};

export default GlobalFooter;
